import CredenciadaCode from "app/api/credenciada-code";
import { handleGenericApiError } from "app/api/error";

import { addLoading, removeLoading } from "./loading";

export const ACTION_SAVE_TOTAL_CREDENCIADA_CODE =
  "hashAgency:ACTION_SAVE_TOTAL_CREDENCIADA_CODE";

export const fetchAccessRedeFacilCode = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await CredenciadaCode.fetchAccessCredenciadaCode(params);
    dispatch({ type: ACTION_SAVE_TOTAL_CREDENCIADA_CODE, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};
